'use strict'

import { rotateImages } from './FileUtils.js'
import { getUploadResult } from '../helpers.js'
import { axiosPost } from '../../axios/axios'

export default class AbstractFilesGroup {
  constructor (config) {
    this.sourceConfig = config.sourceConfig || null // objectId, uploadURL, removeURL, removeRelationships, removeDelayed, removeExternal
  }

  hasFiles () {
  }

  // === Selection

  getSelectedFiles () {
  }

  getSelectedFilesData () {
  }

  clearSelection () {
  }

  // === Changes

  hasChanges () {
    return this.hasFilesToUpload() || this.hasFilesToUpdate() || this.hasFilesToDelete()
  }

  hasFilesToUpload () {
  }

  hasFilesToUpdate () {
  }

  hasFilesToDelete () {
  }

  // === Save

  saveFilesChanges ({ notify, notifyAdditional, progress, target }) {
    return this.removeDeletedFiles({ progress, target })
      .then(() => this.updateFiles({ target }))
      .then(() => this.uploadFiles({ notify, notifyAdditional, progress, target }))
  }

  // === Upload

  getFilesToUploadData () {
  }

  uploadFiles ({ uploadConfig, notify, notifyAdditional, progress, target }) {
    const fileWrappers = []
    // const folderFileWrappers = []
    this.getFilesToUploadData().forEach((fileWrapper) => {
      if (fileWrapper.type !== 'folder') {
        fileWrappers.push(fileWrapper)
      }
      // else {
      //   folderFileWrappers.push(fileWrapper)
      // }
    })

    // TODO
    // this.$q.loading.show({
    //   message: 'Создание папок',
    //   messageColor: 'blue-11',
    //   spinnerColor: 'blue-11'
    // })
    // await this.addFolders(folderFileWrappers)

    if (progress) {
      const progressLabelPart = this.sourceConfig && this.sourceConfig.progressLabelPart || 'файлов'
      const total = fileWrappers.length
      let processedCount = -1
      const progressFn = (errorResponse, successResponse, fileData) => {
        processedCount++
        target.$q.loading.show({
          message: `Загрузка ${progressLabelPart}\n${processedCount} из ${total}`,
          messageColor: 'blue-11',
          spinnerColor: 'blue-11'
        })
      }
      progressFn()
      fileWrappers.forEach(fileData => {
        fileData.callback = progressFn
      })
    }

    return getUploadResult(fileWrappers, notify, target, notifyAdditional, uploadConfig)
  }

  // === Update

  getFilesToUpdateData () {
  }

  updateFiles ({ target }) {
    const filesRels = this.getFilesToUpdateData()
    if (!filesRels || !filesRels.length) {
      return Promise.resolve()
    }

    const filesGroup = filesRels[0].filesGroup
    const sourceConfig = filesGroup.sourceConfig
    const property = filesGroup.property // TODO properties

    if (!sourceConfig || !property) {
      return Promise.reject(Error('Отсутствует конфигурация для изменения структуры папок'))
    }

    const formData = new FormData()

    const objectId = sourceConfig.objectId
    formData.append('id', objectId)
    formData.append('filesRels', JSON.stringify(filesRels))

    if (property) {
      formData.append('property', property)
    }

    return axiosPost({
      url: '/service/delta/opc/updateFolders',
      data: formData,
      onSuccess: () => {
        if (target) {
          target.$q.notify({
            type: 'positive',
            message: 'Успешное изменение структуры папок',
            progress: true,
            timeout: 3000
          })
        }
      },
      onFailure: 'Ошибка изменения структуры папок',
      throws: true
    })
  }

  // === Remove

  getFilesToRemoveData () {
  }

  removeSelectedFiles ({ target }) {
    const removeFilesData = this.getSelectedFilesData()
    return this.removeFiles({ removeFilesData, target })
  }

  removeDeletedFiles ({ progress, target }) {
    const removeFilesData = this.getFilesToRemoveData()
    return this.removeFiles({ removeFilesData, progress, target })
  }

  // @Protected
  removeFiles ({ removeFilesData, progress, target }) {
    if (!removeFilesData || !removeFilesData.length) {
      return Promise.resolve()
    }
    if (!this.sourceConfig) {
      return Promise.reject(Error('Отсутствует конфигурация для удаления'))
    }
    if (this.sourceConfig.removeExternal) {
      return Promise.resolve()
    }

    const folderFilesData = []
    const documentFilesData = []
    removeFilesData.forEach(removeFileData => {
      const fileWrapper = removeFileData.file
      if (fileWrapper.type === 'folder') {
        folderFilesData.push(removeFileData)
      } else {
        documentFilesData.push(removeFileData)
      }
    })

    return this.removeDocumentFiles({ documentFilesData, progress, target })
      .then(() => this.removeFolderFiles({ folderFilesData, progress, target }))
  }

  removeDocumentFiles ({ documentFilesData, progress, target }) {
    if (!documentFilesData || !documentFilesData.length) {
      return Promise.resolve()
    }

    let url
    if (this.sourceConfig.removeRelationships) {
      url = '/service/fileobj/removeobjectfile'
      const rids = documentFilesData.map(documentFileData => documentFileData.file.document.relId)
      url = url + '?rid=' + rids + '&deletefile=' + false + '&deletenonrel=' + false
    } else if (this.sourceConfig.removeTreeNode) {
      const urlParams = new URLSearchParams()
      urlParams.set('id', this.sourceConfig.objectId)
      if (this.property) {
        urlParams.set('property', this.property)
      }

      const documentFilesServiceData = documentFilesData.map(documentFileData => {
        const fileWrapper = documentFileData.file
        return {
          document: fileWrapper.id,
          folder: fileWrapper.parent.id
        }
      })
      urlParams.set('documents', JSON.stringify(documentFilesServiceData))

      url = '/service/delta/opc/removeDocuments?' + urlParams.toString()
    } else {
      if (!this.sourceConfig || !this.sourceConfig.removeURL) {
        return Promise.reject(Error('Отсутствует конфигурация для удаления'))
      }

      const objectId = this.sourceConfig.objectId
      url = this.sourceConfig.removeURL // || '/service/delta/document/deleteFromObject'
      const ids = documentFilesData.map(documentFileData => documentFileData.file.id)
      const categories = documentFilesData.map(documentFileData => documentFileData.file.document.category || null)
      url = url + '?objectId=' + objectId + '&id=' + ids + '&category=' + categories
    }

    if (progress && target) {
      target.$q.loading.show({
        message: 'Удаление файлов: ' + documentFilesData.length,
        messageColor: 'blue-11',
        spinnerColor: 'blue-11'
      })
    }
    return axiosPost({
      url: url,
      onSuccess: (response) => {
        documentFilesData.forEach(documentFileData => {
          const fileWrapper = documentFileData.file
          const filesGroup = documentFileData.filesGroup
          if (!fileWrapper.isToDelete) {
            filesGroup.deleteFile(fileWrapper)
          }
          deleteElementFromArray(filesGroup.filesToDelete, fileWrapper)
        })

        if (target) {
          target.$q.notify({
            type: 'positive',
            message: 'Удалено файлов: ' + documentFilesData.length + '.',
            progress: true,
            timeout: 3000
          })
        }
      },
      onFailure: 'Ошибка удаления файлов',
      throws: true
    })
  }

  removeFolderFiles ({ folderFilesData, progress, target }) {
    if (!folderFilesData || !folderFilesData.length) {
      return Promise.resolve()
    }

    if (progress && target) {
      target.$q.loading.show({
        message: 'Удаление папок',
        messageColor: 'blue-11',
        spinnerColor: 'blue-11'
      })
    }

    const objectId = this.sourceConfig.objectId

    const formData = new FormData()
    formData.append('id', objectId)
    formData.append('foldersIds', folderFilesData.map(folderFileData => folderFileData.file.id).join(','))

    // TODO properties
    const property = folderFilesData[0].filesGroup.property
    if (property) {
      formData.append('property', property)
    }

    return axiosPost({
      url: '/service/delta/opc/removeFolders',
      data: formData,
      onSuccess: (response) => {
        folderFilesData.forEach(folderFileData => {
          const fileWrapper = folderFileData.file
          const filesGroup = folderFileData.filesGroup
          if (!fileWrapper.isToDelete) {
            filesGroup.deleteFile(fileWrapper)
          }
          deleteElementFromArray(filesGroup.filesToDelete, fileWrapper)
        })

        if (target) {
          target.$q.notify({
            type: 'positive',
            message: 'Успешное удаление папок',
            progress: true,
            timeout: 3000
          })
        }
      },
      onFailure: 'Ошибка удаления папок',
      msgTarget: target,
      throws: true
    })
  }

  removePreloadedFile (fileWrapper, filesGroup, target) {
    if (!(fileWrapper.document && fileWrapper.document._preloaded && this.sourceConfig && this.sourceConfig.preloadFormId && this.sourceConfig.preloadFormId === fileWrapper.document.formId)) {
      return Promise.reject(Error('Некорректные параметры удаления предзагруженного файла'))
    }

    if (target) {
      target.$q.loading.show({
        message: 'Удаление файла',
        messageColor: 'blue-11',
        spinnerColor: 'blue-11'
      })
    }

    const document = fileWrapper.document

    const formData = new FormData()
    formData.append('ids', document.id)
    formData.append('formId', document.formId)

    return axiosPost({
      url: '/service/delta/document/deleteFormId',
      data: formData,
      onSuccess: () => {
        if (!fileWrapper.isToDelete) {
          filesGroup.deleteFile(fileWrapper)
        }
        deleteElementFromArray(filesGroup.filesToDelete, fileWrapper)

        if (target) {
          target.$q.notify({
            type: 'positive',
            message: 'Успешное удаление файла',
            progress: true,
            timeout: 3000
          })
        }
      },
      onFailure: 'Ошибка удаления файла',
      msgTarget: target,
      throws: true
    })
  }

  // === Rotate

  rotateSelectedImages (right) {
    const fileWrappers = this.getSelectedFiles()
    return rotateImages(fileWrappers, right).then(() => {
      this.clearSelection()
    })
  }
}

function deleteElementFromArray (array, element) {
  if (array && array.length && element != null) {
    // TODO typeof element !== 'string' => проверять по el.url ?
    const index = array.findIndex(el => el === element)
    if (index !== -1) {
      array.splice(index, 1)
    }
  }
}
